module.exports = __webpack_public_path__ + "static/DC2-ff5799716ab211de2d63282d66705db1.jpg";